import React from 'react';

const Donasi = () => {
  return <div>Donasi (Kosong)</div>;
};

export default Donasi;